import React from 'react'
import { SocialWebTimelineWidget as SocialWebTimelineWidgetType } from 'schemas/SocialWebTimelineWidgetSchema'
import PrerequisiteRunSearchEffect from './PrerequisiteRunSearchEffect'
import RunSearchEffect from './RunSearchEffect'
import TermsAndSoundBite from './TermsAndSoundBite'

interface FluctuationPopularTermsProps {
  widgetSetting: SocialWebTimelineWidgetType
  isAudienceQuery?: boolean
}

const FluctuationPopularTerms = ({
  widgetSetting,
  isAudienceQuery
}: FluctuationPopularTermsProps) => (
  <PrerequisiteRunSearchEffect widgetSetting={widgetSetting} isAudienceQuery={isAudienceQuery}>
    <RunSearchEffect widgetSetting={widgetSetting} isAudienceQuery={isAudienceQuery}>
      <TermsAndSoundBite />
    </RunSearchEffect>
  </PrerequisiteRunSearchEffect>
)

export default FluctuationPopularTerms
